<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import {myBalance} from 'src/components/cabinet/#services/myBalance'
    import {showAlert} from 'src/components/#common/alert/store'
    import step1 from 'src/components/cabinet/staking/1.svg'
    import step2 from 'src/components/cabinet/staking/2.svg'
    import step3 from 'src/components/cabinet/staking/3.svg'
    import {
        stake,
        cancelStake,
        getStakingInfo,
        getStakingBalance,
        getStakingTransactions, getStakingTotalAmount
    } from 'src/components/cabinet/#services/staking'
    import {Link} from 'svelte-routing'
    import {roundNumber} from 'src/components/#common/helpers/helpers'
    import {getDateFormat, numberWithSpaces} from 'src/components/cabinet/#common/helpers'

    getStakingInfo.send()
    getStakingBalance.send()
    getStakingTotalAmount.send()
    getStakingTransactions.send()

    let startDate
    let endDate
    let loading = false

    $: if (!startDate && !endDate && $getStakingInfo?.hasValue) {
        startDate = new Date($getStakingInfo.value?.startDate)
        endDate = new Date($getStakingInfo.value?.endDate)
    }

    let amount
    let minAmount = 10

    function maxAmount() {
        amount = roundNumber(+$myBalance.value.data.WLIS)
    }

    let dateNow = new Date().getTime()
    $: distance = Math.floor((startDate - dateNow) / 1000)

    setInterval(() => {
        if (distance > 0) distance--
    }, 1000)

    $: days = Math.floor(distance / (60 * 60 * 24))
    $: hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60))
    $: minutes = Math.floor((distance % (60 * 60)) / (60))
    $: seconds = Math.floor(distance % 60)

    $: rewardAmount = amount > 0 && amount >= minAmount ? roundNumber(amount * 1.5) : '-'
    $: youWillGet = amount > 0 && amount >= minAmount ? roundNumber(amount * 2.5) : '-'

    async function stakeHandler() {
        try {
            loading = true

            await stake.request({ data: { amount: amount.toString() }})

            amount = ''

            showAlert.set({
                status: 'success',
                text: 'You have successfully made a stake.'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            getStakingBalance.reset()
            getStakingBalance.send()
            getStakingTotalAmount.reset()
            getStakingTotalAmount.send()
            myBalance.send()
        }
    }

    async function cancelStakeHandler() {
        try {
            loading = true

            await cancelStake.request()

            showAlert.set({
                status: 'success',
                text: 'Your stake successfully canceled.'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            getStakingBalance.reset()
            getStakingBalance.send()
            getStakingTotalAmount.reset()
            getStakingTotalAmount.send()
            myBalance.send()
        }
    }

    function getTotalStaked(number) {
        return Math.floor(100/(10000000/number)*100)/100
    }
</script>

<svelte:head>
    <title>Staking</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <Alert />
            <div class="page-title">Staking</div>
            <div class="row">
                <div class="col-xxl-5 col-xl-6 col-md-8 vertical-line">
                    {#if !$getStakingInfo.hasValue && $getStakingInfo.loading}
                        Loading...
                    {:else if !$getStakingInfo.hasValue && $getStakingInfo.error }
                        Something went wrong. Try refreshing the page.
                    {:else if $getStakingInfo.hasValue && distance > 0}
                        <div class="timer">Staking start in: <span>
                            {#if days > 0} {days}d {#if hours > 0}:{/if}{/if}
                            {#if hours > 0} {hours}h {#if minutes > 0}:{/if}{/if}
                            {#if minutes > 0} {minutes}m :{/if}
                            {seconds}s
                        </span></div>
                        <div class="form-card">
                            <div class="row mini-text d-flex align-items-end mb-1">
                                <div class="col-5">Staking amount</div>
                                <div class="col-7 text-right"><Link to="account" class="balance">Wallet balance</Link>:
                                    <span class="nobr">{!$myBalance.hasValue ? "Loading..." : roundNumber(+$myBalance.value.data.WLIS)+' LIS'}</span>
                                </div>
                            </div>
                            <div class="form-group staking-form mb-2">
                                <div class="input-group">
                                    <input type="number" class="form-control" bind:value={amount} placeholder="Enter amount">
                                    <span class="input-group-text empty-input-group-text notranslate">LIS</span>
                                    <button class="btn btn-max-amount" on:click={maxAmount}><span>Max</span></button>
                                </div>
                            </div>
                            <div class="mini-gray-text" class:color-red={amount && amount < minAmount}>Minimum staking amount: {minAmount} LIS</div>
                            <hr class="line">
                            <div class="row mb-3">
                                <div class="col-6">Staking APY</div>
                                <div class="col-6 text-right">150%</div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-6">Weekly reward</div>
                                <div class="col-6 text-right">{#if amount > 0 && amount >= minAmount}{roundNumber(rewardAmount * 0.02)} LIS{:else}3%{/if}</div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-6">Length of staking</div>
                                <div class="col-6 text-right">50 weeks</div>
                            </div>
                            <div class="row mb-3 color-green">
                                <div class="col-6">Reward amount</div>
                                <div class="col-6 text-right">{rewardAmount} LIS</div>
                            </div>
                            <div class="row color-green mb-4">
                                <div class="col-6">You will get:</div>
                                <div class="col-6 text-right">{youWillGet} LIS</div>
                            </div>
                            <hr class="line">
                            <div class="row mb-3">
                                <div class="col-6">Staking start date</div>
                                <div class="col-6 text-right">{startDate ? getDateFormat(startDate) : 'Loading...'}</div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-6">Staking end date</div>
                                <div class="col-6 text-right">{endDate ? getDateFormat(endDate) : 'Loading...'}</div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-6">Total issuance</div>
                                <div class="col-6 text-right">10 000 000 LIS</div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-6">Total staked</div>
                                <div class="col-6 text-right">
                                    8 570 662 LIS ({getTotalStaked(8570662)}%)
                                    {#if $getStakingTotalAmount.hasValue && $getStakingTotalAmount.value?.totalAmount}
                                        <!--{numberWithSpaces(Math.floor($getStakingTotalAmount.value.totalAmount))} LIS-->
                                        <!--({getTotalStaked($getStakingTotalAmount.value.totalAmount)}%)-->
                                    {:else}
                                        <!--Loading...-->
                                    {/if}
                                </div>
                            </div>
                            <button class="btn btn-primary w-100" on:click={stakeHandler} class:loading={loading} disabled={!amount || loading || amount < minAmount}>Staking</button>
                        </div>
                    {:else}
                        <div class="form-card after-start">
                            <div class="row mb-30">
                                <div class="col-6 color-lightgray">Your deposit</div>
                                <div class="col-6 text-right">
                                    {#if !$getStakingBalance.hasValue && $getStakingBalance.loading}
                                        Loading...
                                    {:else if $getStakingBalance.hasValue && $getStakingBalance.value?.stakingBalance?.amount}
                                        {roundNumber(+$getStakingBalance.value.stakingBalance.amount)} LIS
                                    {:else}
                                        0 LIS
                                    {/if}
                                </div>
                            </div>
                            <div class="row mb-30">
                                <div class="col-6 color-lightgray">Staking APY</div>
                                <div class="col-6 text-right">150%</div>
                            </div>
                            <div class="row mb-30">
                                <div class="col-6 color-lightgray">Weekly reward</div>
                                <div class="col-6 text-right">3%</div>
                            </div>
                            <div class="row mb-30">
                                <div class="col-6 color-lightgray">Length of staking</div>
                                <div class="col-6 text-right">50 weeks</div>
                            </div>
                            <div class="row mb-30">
                                <div class="col-6 color-lightgray">You will get</div>
                                <div class="col-6 text-right color-green">
                                    {#if !$getStakingBalance.hasValue && $getStakingBalance.loading}
                                        Loading...
                                    {:else if $getStakingBalance.hasValue && $getStakingBalance.value?.stakingBalance?.amount}
                                        {roundNumber(+$getStakingBalance.value.stakingBalance.amount * 2.5)} LIS
                                    {:else}
                                        0 LIS
                                    {/if}
                                </div>
                            </div>
                            <div class="row mb-30">
                                <div class="col-6 color-lightgray">Date start</div>
                                <div class="col-6 text-right">{startDate ? getDateFormat(startDate) : 'Loading...'}</div>
                            </div>
                            <div class="row mb-30">
                                <div class="col-6 color-lightgray">Date end</div>
                                <div class="col-6 text-right">{endDate ? getDateFormat(endDate) : 'Loading...'}</div>
                            </div>
                            <div class="row mb-30">
                                <div class="col-6 color-lightgray">Total issuance</div>
                                <div class="col-6 text-right">10 000 000 LIS</div>
                            </div>
                            <div class="row">
                                <div class="col-6 color-lightgray">Total staked</div>
                                <div class="col-6 text-right">
                                    8 570 662 LIS ({getTotalStaked(8570662)}%)
                                    {#if $getStakingTotalAmount.hasValue && $getStakingTotalAmount.value?.totalAmount}
                                        <!--{numberWithSpaces(Math.floor($getStakingTotalAmount.value.totalAmount))} LIS-->
                                        <!--({getTotalStaked($getStakingTotalAmount.value.totalAmount)}%)-->
                                    {:else}
                                        <!--Loading...-->
                                    {/if}
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>
                <div class="col-xxl-7 col-xl-6 col-md-8 right-side">
                    {#if !$getStakingBalance.hasValue && $getStakingBalance.loading}
                        <span class="d-none d-xl-block">Loading...</span>
                    {:else if !$getStakingBalance.hasValue && $getStakingBalance.error }
                        <span class="d-none d-xl-block">Something went wrong. Try refreshing the page.</span>
                    {:else if $getStakingBalance.hasValue && $getStakingBalance.value}
                        {#if $getStakingBalance.value?.isUserParticipate}
                            {#if distance > 0}
                                <div class="page-subtitle">Your bid</div>
                                <div class="page-description">All your staking stakes are displayed here, all stakes are summed up.</div>
                                <div class="my-transactions-table">
                                    <div class="transactions-table-header">
                                        <div>Date</div>
                                        <div>Amount</div>
                                        <div>Action</div>
                                    </div>
                                    <div class="transactions-table-body">
                                        <div class="transactions-table-row">
                                            <div>{getDateFormat($getStakingBalance.value?.stakingBalance?.updatedAt)}</div>
                                            <div>{roundNumber(+$getStakingBalance.value?.stakingBalance?.amount)} LIS</div>
                                            <div>
                                                <button class="btn btn-primary btn-cancel" on:click={cancelStakeHandler}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            {:else}
                                <div class="page-subtitle">Weekly rewards</div>
                                <div class="page-description">Shown here are your weekly rewards at 3% from your locked deposit.</div>
                                {#if !$getStakingTransactions.hasValue && $getStakingTransactions.loading}
                                    <div class="my-transactions-table text-center">Loading...</div>
                                {:else if !$getStakingTransactions.hasValue && $getStakingTransactions.error }
                                    <div class="my-transactions-table text-center">Something went wrong. Try refreshing the page.</div>
                                {:else if $getStakingTransactions.hasValue}
                                    <div class="my-transactions-table">
                                        <div class="transactions-table-header two-columns">
                                            <div>Date</div>
                                            <div>Amount</div>
                                        </div>
                                        <div class="transactions-table-body">
                                            {#each $getStakingTransactions.value as {debit, createdAt}}
                                                <div class="transactions-table-row two-columns">
                                                    <div>{getDateFormat(createdAt)}</div>
                                                    <div class="color-green">+{roundNumber(+debit)} LIS</div>
                                                </div>
                                            {/each}
                                        </div>
                                    </div>
                                {/if}
                            {/if}
                        {:else}
                            <div class="page-subtitle ml-110">How it works</div>
                            <div class="info-row">
                                <div class="step">1</div>
                                <div class="info-wrapper">
                                    <div class="cubes"><div></div><div></div><div></div></div>
                                    <div class="info-card">
                                        <div class="row">
                                            <div class="col-auto d-none d-xxl-block">
                                                <div class="icon"><img src="{step1}" alt=""></div>
                                            </div>
                                            <div class="col">
                                                <div class="info-title">Lock your LIS</div>
                                                <div class="info-description">You can block a certain amount of LIS tokens to get 150% rewards. Once staking has started, you will not be able to change the deposit amount.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="info-row">
                                <div class="step">2</div>
                                <div class="info-wrapper">
                                    <div class="cubes"><div></div><div></div><div></div></div>
                                    <div class="info-card">
                                        <div class="row">
                                            <div class="col-auto d-none d-xxl-block">
                                                <div class="icon"><img src="{step2}" alt=""></div>
                                            </div>
                                            <div class="col">
                                                <div class="info-title">Keeping your LIS</div>
                                                <div class="info-description">We hold your deposit safely for 50 weeks. You will not be able to use your LIS tokens during the staking period.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="info-row">
                                <div class="step">3</div>
                                <div class="info-wrapper">
                                    <div class="cubes"><div></div><div></div><div></div></div>
                                    <div class="info-card">
                                        <div class="row">
                                            <div class="col-auto d-none d-xxl-block">
                                                <div class="icon"><img src="{step3}" alt=""></div>
                                            </div>
                                            <div class="col">
                                                <div class="info-title">Getting rewards</div>
                                                <div class="info-description">You will get 3% off your deposit every week. Rewards will be released for use immediately. After 50 weeks of staking you will get your whole  deposit and meanwhile the time earned rewards.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        {/if}
                    {/if}
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .form-card {
        background: #26244D;
        border: 2px solid #494591;
        border-radius: 20px;
        padding: 30px;
    }

    .form-card {
        background: #26244D;
        border: 2px solid #494591;
        border-radius: 20px;
        padding: 30px;
        margin-right: 74px;
        font-size: 14px;
        line-height: 20px;
    }

    .form-card :global(.balance) {
        color: #CAD5E0;
        text-decoration: none;
    }

    .form-card :global(.balance:hover) {
        text-decoration: underline;
    }

    .text-right {
        text-align: right;
    }

    .mini-text {
        font-size: 13px;
        color: #CAD5E0;
    }

    .mini-gray-text {
        font-size: 13px;
        color: #61758A;
    }

    .line {
        background: #617E8A;
        margin: 30px 0;
    }

    .staking-form .form-control {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
        padding: 0 15px;
        border-right: 0;
        border-radius: 8px 0 0 8px;
    }

    .staking-form .form-control:focus {
        box-shadow: none;
    }

    .staking-form .input-group-text {
        color: #c8cbcd;
        background: #585F67;
        min-width: 70px;
        justify-content: center;
    }

    .staking-form .empty-input-group-text {
        background: none;
        border-left: 0;
        border-right: 0;
        min-width: initial;
        padding: 0 30px;
        font-size: 20px;
        color: #61758A;
        transition: .25s;
    }

    .staking-form .form-control:focus,
    .staking-form .form-control:focus + span,
    .staking-form .form-control:focus ~ button {
        border-color: #FF5D1C;
    }

    .btn-max-amount {
        background: none;
        color: white;
        border: 1px solid #CAD5E0;
        box-shadow: inset 0 0 0 1px #2e3549;
        border-left: 0;
        border-radius: 8px;
        min-width: 80px;
        height: 46px;
        font-size: 14px;
        font-weight: 500;
    }

    .btn-max-amount:before {
        content: "";
        background: #61758A;
        border-radius: 6px;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        position: absolute;
        left: 1px;
        top: 1px;
        transition: .25s;
    }

    .btn-max-amount:hover:before {
        background: #4e6174;
    }

    .btn-max-amount span {
        position: relative;
        z-index: 2;
    }

    .btn-max-amount:focus {
        box-shadow: none;
    }

    .color-green {
        font-weight: 500;
        color: #27AE60;
    }

    .info-row {
        display: flex;
        align-items: center;
        position: relative;
    }

    .info-wrapper {
        background: #61758A;
        border-radius: 10px;
        border: 1px solid white;
        padding: 20px;
        margin-bottom: 20px;
    }

    .info-card {
        background: rgba(46, 53, 73, 0.5);
        border-radius: 8px;
        padding: 20px;
    }

    .cubes {
        display: flex;
        margin-bottom: 20px;
    }

    .cubes div {
        width: 15px;
        height: 15px;
        background: #cfd5dc;
        border-radius: 4px;
        margin-right: 10px;
    }

    .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #343d49;
        border-radius: 50%;
        margin-right: 6px;
        padding: 10px;
        width: 94px;
        height: 94px;
    }

    .icon img {
        width: 100%;
    }

    .info-title {
        font-weight: 600;
        font-size: 24px;
        line-height: 28px;
        margin-bottom: 10px;
        color: white;
    }

    .info-description {
        font-weight: 400;
        font-size: 16px;
        line-height: 1.5;
        color: white;
    }

    .step {
        min-width: 60px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background: #323a3f;
        border: 1px solid #CAD5E0;
        font-weight: 500;
        font-size: 30px;
        line-height: 36px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 50px;
        margin-top: -20px;
    }

    .info-row:not(:last-child) .step:after {
        content: "";
        height: calc(100% - 100px);
        width: 1px;
        background: #61758A;
        position: absolute;
        top: calc(50% + 40px);
        left: 30px;
    }

    .vertical-line {
        position: relative;
    }

    .vertical-line:after {
        content: "";
        height: 100%;
        right: 12px;
        width: 2px;
        background: #343168;
    }

    .right-side {
        padding-left: 50px;
    }

    .ml-110 {
        margin-left: 110px;
    }

    .timer {
        margin: 0 74px 30px 0;
        background: #31363d;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);
        border-radius: 10px;
        height: 94px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        line-height: 1.5;
    }

    .timer span {
        font-weight: 600;
        padding-left: 20px;
        font-family: monospace;
    }

    .mini-gray-text.color-red {
        color: #f44336;
    }

    .form-card.after-start {
        font-size: 18px;
    }

    .mb-30 {
        margin-bottom: 30px;
    }

    .color-lightgray {
        color: #9592CD;
    }

    .page-description {
        margin: -10px 0 30px 0;
        font-size: 16px;
        color: #9592CD;
    }

    .transactions-table-header {
        display: flex;
        width: 100%;
        margin-bottom: 15px;
    }

    .transactions-table-header > div {
        width: 50%;
        padding: 15px 50px;
        background: #CAD5E0;
        color: #272C33;
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
    }

    .transactions-table-header > div:first-child {
        border-radius: 8px 0 0 8px;
    }

    .transactions-table-header > div:last-child {
        border-radius: 0 8px 8px 0;
    }

    .transactions-table-row {
        border: 1px solid #CAD5E0;
        border-radius: 8px;
        display: flex;
        width: 100%;
        margin-bottom: 10px;
    }

    .transactions-table-row > div {
        width: 50%;
        padding: 15px 50px;
        font-size: 18px;
        line-height: 20px;
        font-weight: 500;
        display: flex;
        align-items: center;
        white-space: nowrap;
    }

    .my-transactions-table {
        margin: 30px auto 0;
        max-width: 1174px;
    }

    .btn.btn-primary.btn-cancel {
        background: #61758A;
    }

    .btn.btn-primary.btn-cancel:hover {
        background: #4e6174;
    }

    @media(max-width: 1800px) {
        .timer {
            font-size: 18px;
        }
    }

    @media(max-width: 1600px) {
        .timer,
        .form-card {
            margin-right: 54px;
        }

        .right-side {
            padding-left: 40px;
        }
    }

    @media(max-width: 1500px) {
        .form-card {
            margin-right: 24px;
        }

        .right-side {
            padding-left: 12px;
        }

        .timer {
            margin-right: 24px;
        }

        .transactions-table-row > div {
            font-size: 16px;
            padding: 15px 30px;
        }

        .ml-110 {
            margin-left: 84px;
        }

        .step {
            margin-right: 24px;
        }
    }

    @media(max-width: 1199px) {
        .right-side {
            padding-left: 12px;
        }

        .form-card {
            margin: 0 0 40px 0;
        }

        .vertical-line:after {
            display: none;
        }

        .timer {
            margin-right: 0;
        }

        .step {
            margin: 0 auto 20px 0;
        }

        .step:after {
            display: none;
        }

        .ml-110 {
            margin-left: 0;
        }

        .info-row {
            flex-wrap: wrap;
        }

        .info-row:last-child .info-wrapper {
            margin-bottom: 0;
        }

        .info-title {
            font-size: 22px;
        }

        .info-description {
            font-size: 15px;
        }
    }

    @media(max-width: 767px) {
        .form-card,
        .form-card.after-start {
            margin: 0 0 30px 0;
            padding: 20px;
            font-size: 16px;
        }

        .staking-form .empty-input-group-text {
            padding: 0 20px;
        }

        .timer {
            margin-bottom: 15px;
            font-size: 15px;
            height: 70px;
        }

        .step {
            min-width: 30px;
            width: 30px;
            height: 30px;
            font-size: 18px;
            position: absolute;
            top: 15px;
            left: 20px;
            background: rgba(46, 53, 73, 0.5);
            border: 0;
        }

        .cubes {
            opacity: 0;
        }

        .transactions-table-header > div {
            width: 33.33%;
            padding: 12px 15px;
        }

        .transactions-table-row > div {
            font-size: 15px;
            padding: 10px 15px;
            width: 33.33%;
        }

        .transactions-table-header.two-columns > div,
        .transactions-table-row.two-columns > div {
            width: 50%;
        }

        .line {
            margin: 20px 0;
        }

        .mb-30 {
            margin-bottom: 24px;
        }
    }
</style>
